<div class="absolute w-full h-full text-secondary-800">
	<div
		class="absolute -translate-x-1/2 top-1/2 -translate-y-1/2 flex flex-col justify-center items-center text-xl 2xl:text-2xl left-1/4"
	>
		<ui-icon [icon]="icon()" size="3xl" class="mb-5"></ui-icon>
		<div>{{ 'summary.top_3' | translate }}</div>
		<div class="font-bold">
			{{ slideTitle() | translate | uppercase }}
		</div>
	</div>
	@if (values()?.length > 0) {
		<div class="absolute left-2/5 top-1/2 -translate-y-1/2">
			<ol class="list-decimal text-3xl 2xl:text-4xl font-bold list-inside">
				@for (item of values(); track item.serial) {
					<li class="py-2">
						{{ item.name }}
						<span class="text-xl 2xl:text-2xl font-normal">({{ item.value }})</span>
					</li>
				}
			</ol>
		</div>
	}
</div>
